import { Box, Progress, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface ChatLimitProgressProps {
  remaining: number;
  limit: number;
}

export const ChatLimitProgress = ({ remaining, limit }: ChatLimitProgressProps) => {
  const { t } = useTranslation();

  const getBarColor = () => {
    if (limit <= 0) return 'primary';
    const ratio = remaining / limit;
    if (ratio > 0.5) return 'primary';
    if (ratio > 0.2) return 'semantics.warningLight';
    return 'semantics.error';
  };

  return (
    <Box w="full" maxW="chat" mx="auto" px={1}>
      <Progress.Root
        value={Math.max(remaining, 0)}
        max={Math.max(limit, 1)}
        w="full"
        translations={{ value: () => t('chat.monthlyLimit', { remaining, limit }) }}
      >
        <Text mb={1} fontSize="xs" fontWeight="semibold" color="text.secondary">
          {t('chat.monthlyLimit', { remaining, limit })}
        </Text>
        <Progress.Track h={1.5} borderRadius="full" bg="gray.200">
          <Progress.Range borderRadius="full" bg={getBarColor()} />
        </Progress.Track>
      </Progress.Root>
    </Box>
  );
};
